import './audit-campaign-featured-list.scss'

import { map } from '@skinsoft/data-store';
import { AliasDataStore as CollaboratorDataStore, AuditCampaignDataStore } from '@skinsoft/entity';
import { AuditCampaignFeatured, toCampaignFeatured$ } from '@skinsoft/entity-ui';
import { ReactiveVue } from '@skinsoft/reactive-vue';
import { SearchParams } from '@skinsoft/search';
import { first, pluck, tap } from 'rxjs/operators';
import Component from 'vue-class-component';
import { Watch } from 'vue-property-decorator';
import { NB_CAMPAIGNS_SEARCH_RESULT_CHANGED_TOPIC } from '../../../../busTopics';
import { AuditCampaignFeaturedCard } from '../audit-campaign-featured-card';

const AUDIT_CAMPAIGN_FEATURED_ITEM_COUNT = 5;

@Component({
    components: {
        sAuditCampaignFeaturedCard: AuditCampaignFeaturedCard
    },
    props: ['listState', 'searchParams', 'emptyMessage', 'clickAction'],
    template: require('./audit-campaign-featured-list.html')
})
export class AuditCampaignFeaturedList extends ReactiveVue {

    public searchParams: SearchParams;
    private totalResults: number = 0;
    private campaignFeatureds: AuditCampaignFeatured[] = [];

    private clickAction: string

    private $auditCampaignDataStore: AuditCampaignDataStore;
    private $collaboratorDataStore: CollaboratorDataStore;

    private async subscribe() {
        const locale = this.$i18n.locale
        const sortObject =
            this.searchParams.sortType === ''
                ? null
                : { entityFields: [this.searchParams.sortType], sortAsc: this.searchParams.sortAsc };

        // Get current user associated collaborator
        const userId = await localStorage.getItem("userId");
        const collaboratorId = userId ? (await this.$collaboratorDataStore.getCollaboratorByUserId(userId).pipe(first()).toPromise()).id : null;

        // advancedSearch filtering field (on status)
        const advancedSearches =
            [{
                // authorizedAuditor equals to current collaborator
                leftCriteria: { operator: "equals", value: { "text": "ui.lifecycle-state.inProgress", type: "text" }, entityField: "5e2713835111f87e825ede00", type: "criteria" },
                linkOperator: collaboratorId ? "AND" : null,
                // campaign workflow status equals to 'inProgress'
                rightCriteria: collaboratorId ? { operator: "equals", value: { completeSearch: false, refId: collaboratorId, type: "ref" }, entityField: "5e2713835111f87e825ede23", type: "criteria" } : null,
                type: "requestSearch",
            }];

        this.subscribeTo(
            this.$auditCampaignDataStore
                .searchAll(this.searchParams.queryText, sortObject, this.searchParams.nbResults, ['auditProject'], this.searchParams.startAt, advancedSearches)
                .pipe(
                    tap(results => {
                        this.totalResults = results.totalSize
                    }),
                    pluck('allData'),
                    map((value) => toCampaignFeatured$(value, locale))
                )
            ,
            (campaignFeatureds: AuditCampaignFeatured[]) => {
                this.campaignFeatureds = campaignFeatureds;

                this.emitOnBus(NB_CAMPAIGNS_SEARCH_RESULT_CHANGED_TOPIC, { totalResults: this.totalResults })
            }
            , 'campaignFeatureds'
        )
    }

    private unsubscribe() {
        this.unsubscribeFrom('campaignFeatureds');
    }


    @Watch('searchParams', { immediate: true, deep: true })
    private onSearchParamsChange() {
        // Testing all search params presence to avoid useless search query during params setting
        if (this.searchParams.nbResults && this.searchParams.sortType) {
            this.unsubscribe();
            this.campaignFeatureds = Array(AUDIT_CAMPAIGN_FEATURED_ITEM_COUNT).fill(null);
            this.$emit('totalCount', null);
            this.subscribe();
        }
    }

}